import { useNavigate } from "@tanstack/react-router";
import { signOut } from "aws-amplify/auth";
import { Header } from "@/components/header";
import { Main } from "@/components/main";
import { ProfileDropdown } from "@/components/profile-dropdown";
import { Search } from "@/components/search";
import { ThemeSwitch } from "@/components/theme-switch";
import { TopNav } from "@/components/top-nav";

interface Props {
  children: React.ReactNode;
  pageTitle: string;
  pageDescription?: string;
  rightContent?: React.ReactNode;
  topNav?: {
    title: string;
    href: string;
    isActive: boolean;
    disabled: boolean;
  }[];
}

export default function UserLayout({
  children,
  pageTitle,
  rightContent,
  topNav = [],
  pageDescription,
}: Props) {
  const navigate = useNavigate();

  return (
    <>
      <Header>
        <TopNav links={topNav} />
        <div className="ml-auto flex items-center space-x-4">
          <Search />
          <ThemeSwitch />
          <ProfileDropdown
            name={"User"}
            email={"user@example.com"}
            onProfileClick={() => {
              navigate({
                to: "/dashboard",
              });
            }}
            onSettingsClick={() => {
              navigate({
                to: "/dashboard",
              });
            }}
            onLogout={async () => {
              signOut();
              navigate({
                to: "/sign-in-2",
              });
            }}
          />
        </div>
      </Header>

      <Main>
        <div className="mb-2 flex items-center justify-between space-y-2">
          <div>
            <h2 className="text-2xl font-bold tracking-tight">{pageTitle}</h2>
            {pageDescription && (
              <p className="text-muted-foreground">{pageDescription}</p>
            )}
          </div>
          {rightContent}
        </div>
        {children}
      </Main>
    </>
  );
}
